import { useContext, useState } from "react";
import { Card, Row, Col, Button } from "react-bootstrap";
import {Plus, Dash, XSquare} from 'react-bootstrap-icons';
import { CartContext } from "../context/cartcontext";

const CartElement = ({id}) => {

    const {cart, setCart} = useContext(CartContext);
    var i = 0;

    for (i = 0; i < cart.length; i++){
        if (id === cart[i].id){
            break;
        }
    }
    const [count, setCount] = useState(cart[i].count);

    const del = (e) => {
        let arr = [...cart];
        let index = arr.indexOf(cart[i]);
        if (index !== -1) {
            arr.splice(index, 1);
            setCart(arr);
        }
    }

    const add = (e) =>{
        //cart[i].count = cart[i].count + 1;
        let arr = [...cart];
        let index = arr.indexOf(cart[i]);
        if (index !== -1) {
            arr[index].count = arr[index].count + 1;
            setCart(arr);
        }
        setCount(cart[i].count);
    }

    const sub = (e) =>{
        if (cart[i].count === 1) {
            let arr = [...cart];
            let index = arr.indexOf(cart[i]);
            if (index !== -1) {
                arr.splice(index, 1);
                setCart(arr);
            }
        }
        else if (cart[i].count > 0){
            //cart[i].count = cart[i].count - 1;
            let arr = [...cart];
            let index = arr.indexOf(cart[i]);
            if (index !== -1) {
                arr[index].count = arr[index].count - 1;
                setCart(arr);
            }
            setCount(cart[i].count);
        }
    }


    return(
        <div className = 'cartElement'>
        <Card>
            <Card.Header as="h5">
                <Row>
                    <Col>
                        {cart[i].name}
                    </Col>
                    <Col className = 'text-right'>
                        {cart[i].price * count}
                    </Col>
                </Row>
            </Card.Header>

            <Card.Body>
                <Row>
                    <Col>
                        Price
                    </Col>
                    <Col className = 'text-right'>
                        {cart[i].price}
                    </Col>
                </Row>
                <Row>
                <Button onClick = {del} variant = 'd'><XSquare/></Button>
                    <Col className = 'text-right'>
                        <Button variant = 'outline' onClick = {sub}><Dash/></Button>
                        <Button variant = 'outline'>{count}</Button>
                        <Button variant = 'outline' onClick = {add}><Plus/></Button>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
        </div>
    );
}

export default CartElement;